import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import EmployeesService from "../../../../../../services/HRM/EmployeesService";
import { Translate } from "../../../../../Enums/Tranlate";
import DeleteModal from "../../../../../common/DeleteModal";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const employeesService = new EmployeesService();

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item.id}</strong>
			</td>
			<td>{item?.name}</td>
			<td>{item?.civil_id}</td>
			<td>{item.job_title}</td>
			<td>{item.department?.name}</td>
			<td>{item?.start_resignation_date?.split("T")[0] || "-"}</td>
			<td>{item?.end_resignation_date?.split("T")[0] || "-"}</td>
			<td>
				{/* {(isExist("edit_employees") && isExist("delete_employees")) &&  */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_employees") &&  */}
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}>
							{" "}
							{Translate[lang]?.edit}
						</Dropdown.Item>
						{/* } */}
					</Dropdown.Menu>
				</Dropdown>
				{/* } */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={employeesService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
